import React from "react";
import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import { Controller } from "react-hook-form";
import { styleEndowment } from "../styleEndowment";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import deLocale from "date-fns/locale/es";
import { listAmount } from "../headers";
import { StyledCheckbox } from "../../../utils/functionsUtils";

const NextFormEndowment = ({
  register,
  control,
  errors,
  handleSubmit,
  onSubmit,
  maestras,
  regionals,
  sizePants,
  navigateToEndowment,
  handleChangeChecked,
  isChekedOther,
  isDisabledBtn,
  onChangeClothes,
}) => {
  const classes = styleEndowment();

  const pantsSize = sizePants ? sizePants : maestras?.tallaNumerosMasculino;

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid container>
            <Typography
              component="h6"
              variant="h6"
              className={classes.titleContractor}
            >
              Información del colaborador
            </Typography>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("firstName") &&
                errors["firstName"].message
              }
            >
              <Controller
                name="firstName"
                control={control}
                defaultValue=""
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    name="firstName"
                    label="Primer nombre *"
                    variant="outlined"
                    margin="dense"
                    size="small"
                    inputRef={register}
                    fullWidth
                    className={classes.inputFormDisabled}
                    disabled={true}
                    error={
                      errors.hasOwnProperty("firstName") &&
                      errors["firstName"].message
                    }
                  />
                )}
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("firstName") &&
                  errors["firstName"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("secondName") &&
                errors["secondName"].message
              }
            >
              <Controller
                name="secondName"
                control={control}
                defaultValue=""
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    name="secondName"
                    label="Segundo nombre"
                    variant="outlined"
                    margin="dense"
                    size="small"
                    inputRef={register}
                    fullWidth
                    className={classes.inputFormDisabled}
                    disabled={true}
                    error={
                      errors.hasOwnProperty("secondName") &&
                      errors["secondName"].message
                    }
                  />
                )}
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("secondName") &&
                  errors["secondName"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("surname") && errors["surname"].message
              }
            >
              <Controller
                name="surname"
                control={control}
                defaultValue=""
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    name="surname"
                    label="Primer apellido *"
                    variant="outlined"
                    margin="dense"
                    size="small"
                    inputRef={register}
                    fullWidth
                    className={classes.inputFormDisabled}
                    disabled={true}
                    error={
                      errors.hasOwnProperty("surname") &&
                      errors["surname"].message
                    }
                  />
                )}
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("surname") && errors["surname"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("secondSurname") &&
                errors["secondSurname"].message
              }
            >
              <Controller
                name="secondSurname"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    name="secondSurname"
                    label="Segundo apellido"
                    variant="outlined"
                    margin="dense"
                    size="small"
                    inputRef={register}
                    fullWidth
                    className={classes.inputFormDisabled}
                    disabled={true}
                    error={
                      errors.hasOwnProperty("secondSurname") &&
                      errors["secondSurname"].message
                    }
                  />
                )}
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("secondSurname") &&
                  errors["secondSurname"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControl
              variant="outlined"
              fullWidth
              className={classes.inputFormDisabled}
              size="small"
              error={
                !!errors.hasOwnProperty("regionalId") &&
                errors["regionalId"].message
              }
            >
              <InputLabel htmlFor="outlined-select-regionalId" shrink={true}>
                Regional *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                name="regionalId"
                inputRef={register}
                defaultValue=""
                className={classes.inputFormDisabled}
                disabled={true}
                label="Regional *"
                size="small"
                notched={true}
                inputProps={{
                  name: "regionalId",
                  id: "outlined-select-regionalId",
                }}
                as={
                  <Select>
                    {regionals.map((res) => (
                      <MenuItem
                        key={res?.id}
                        value={res?.id}
                        className={classes.menuItem}
                      >
                        {res.name}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("regionalId") &&
                  errors["regionalId"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              className={classes.formControlGen}
              size="small"
              error={
                !!errors.hasOwnProperty("gender") && errors["gender"].message
              }
            >
              <InputLabel htmlFor="outlined-select-gender" shrink={true}>
                Género *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                name="gender"
                inputRef={register}
                defaultValue=""
                className={classes.inputForm}
                label="Género *"
                size="small"
                notched={true}
                inputProps={{
                  name: "gender",
                  id: "outlined-select-gender",
                }}
                as={
                  <Select>
                    {maestras?.generos?.map((res) => (
                      <MenuItem
                        key={res.key}
                        value={res.key}
                        className={classes.menuItem}
                      >
                        {res.value}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("gender") && errors["gender"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
              <Controller
                control={control}
                name="deliverDate"
                placeholder="dd/mm/yyyy"
                size="small"
                defaultValue={null}
                as={
                  <KeyboardDatePicker
                    fullWidth
                    inputRef={register}
                    inputVariant="outlined"
                    variant="inline"
                    format="dd/MM/yyyy"
                    dateFormat="DD/MM/YYYY"
                    className={classes.inputForm}
                    label="Fecha de entrega *"
                    InputLabelProps={{ shrink: true }}
                    error={
                      !!errors.hasOwnProperty("deliverDate") &&
                      errors["deliverDate"].message
                    }
                    helperText={
                      errors.hasOwnProperty("deliverDate") &&
                      errors["deliverDate"].message
                    }
                    minDate={new Date()}
                    minDateMessage={"No puede ser menor a la fecha actual"}
                    //maxDate={maxDate}
                  />
                }
              />
            </MuiPickersUtilsProvider>
          </Grid>

          <Grid container>
            <Typography component="h6" variant="h6" style={{ marginTop: 20 }}>
              Información de la dotación
            </Typography>
          </Grid>

          <Grid container spacing={2} style={{ marginTop: 20 }}>
            <Grid item xs={12} md={3} lg={3}>
              <Typography component="h6" variant="subtitle1">
                Camisa administrativa
              </Typography>
            </Grid>

            <Grid item xs={6} md={2} lg={2}>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.inputForm}
                size="small"
                error={
                  !!errors.hasOwnProperty("sizeShirt") &&
                  errors["sizeShirt"].message
                }
              >
                <InputLabel htmlFor="outlined-select-sizeShirt" shrink={true}>
                  Talla
                </InputLabel>
                <Controller
                  fullWidth
                  control={control}
                  name="sizeShirt"
                  inputRef={register}
                  defaultValue=""
                  className={classes.inputForm}
                  label="Talla"
                  size="small"
                  notched={true}
                  inputProps={{
                    name: "sizeShirt",
                    id: "outlined-select-sizeShirt",
                  }}
                  as={
                    <Select>
                      <MenuItem
                        className={classes.menuItem}
                        aria-label="None"
                        value={null}
                      >
                        <em>&nbsp;</em>
                      </MenuItem>
                      {maestras?.tallaLetras?.map((res) => (
                        <MenuItem
                          key={res}
                          value={res}
                          className={classes.menuItem}
                        >
                          {res}
                        </MenuItem>
                      ))}
                    </Select>
                  }
                />
                <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                  {errors.hasOwnProperty("sizeShirt") &&
                    errors["sizeShirt"].message}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={6} md={2} lg={2}>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.inputForm}
                size="small"
                error={
                  !!errors.hasOwnProperty("amountShirt") &&
                  errors["amountShirt"].message
                }
              >
                <InputLabel htmlFor="outlined-select-amountShirt" shrink={true}>
                  Cantidad
                </InputLabel>
                <Controller
                  fullWidth
                  name="amountShirt"
                  control={control}
                  size="small"
                  defaultValue=""
                  render={(props) => (
                    <Select
                      inputRef={register}
                      label="Cantidad"
                      notched={true}
                      className={classes.inputForm}
                      inputProps={{
                        name: "amountShirt",
                        id: "outlined-select-amountShirt",
                      }}
                      onChange={(e) => {
                        props.onChange(e);
                        onChangeClothes(e, "shirt");
                      }}
                    >
                      <MenuItem
                        className={classes.menuItem}
                        aria-label="None"
                        value={null}
                      >
                        <em>&nbsp;</em>
                      </MenuItem>
                      {listAmount?.map((res) => (
                        <MenuItem
                          key={res.id}
                          value={res.id}
                          className={classes.menuItem}
                        >
                          {res.value}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                />
                <FormHelperText style={{ color: "#f44336", paddingLeft: 10 }}>
                  {errors.hasOwnProperty("amountShirt") &&
                    errors["amountShirt"].message}
                </FormHelperText>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={2} style={{ marginTop: 20 }}>
            <Grid item xs={12} md={3} lg={3}>
              <Typography component="h6" variant="subtitle1">
                Pijamas operativas
              </Typography>
            </Grid>

            <Grid item xs={12} md={2} lg={2}>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.inputForm}
                size="small"
                error={
                  !!errors.hasOwnProperty("pijamaSize") &&
                  errors["pijamaSize"].message
                }
              >
                <InputLabel htmlFor="outlined-select-pijamaSize" shrink={true}>
                  Talla
                </InputLabel>
                <Controller
                  fullWidth
                  control={control}
                  name="pijamaSize"
                  inputRef={register}
                  defaultValue=""
                  className={classes.inputForm}
                  label="Talla"
                  size="small"
                  notched={true}
                  inputProps={{
                    name: "pijamaSize",
                    id: "outlined-select-pijamaSize",
                  }}
                  as={
                    <Select>
                      <MenuItem
                        className={classes.menuItem}
                        aria-label="None"
                        value={null}
                      >
                        <em>&nbsp;</em>
                      </MenuItem>
                      {maestras?.tallaLetras?.map((res) => (
                        <MenuItem
                          key={res}
                          value={res}
                          className={classes.menuItem}
                        >
                          {res}
                        </MenuItem>
                      ))}
                    </Select>
                  }
                />
                <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                  {errors.hasOwnProperty("pijamaSize") &&
                    errors["pijamaSize"].message}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={6} md={2} lg={2}>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.inputForm}
                size="small"
                error={
                  !!errors.hasOwnProperty("pijamaAmount") &&
                  errors["pijamaAmount"].message
                }
              >
                <InputLabel
                  htmlFor="outlined-select-pijamaAmount"
                  shrink={true}
                >
                  Cantidad
                </InputLabel>
                <Controller
                  fullWidth
                  name="pijamaAmount"
                  control={control}
                  size="small"
                  defaultValue=""
                  render={(props) => (
                    <Select
                      inputRef={register}
                      label="Cantidad"
                      notched={true}
                      className={classes.inputForm}
                      inputProps={{
                        name: "pijamaAmount",
                        id: "outlined-select-pijamaAmount",
                      }}
                      onChange={(e) => {
                        props.onChange(e);
                        onChangeClothes(e, "pijama");
                      }}
                    >
                      <MenuItem
                        className={classes.menuItem}
                        aria-label="None"
                        value={null}
                      >
                        <em>&nbsp;</em>
                      </MenuItem>
                      {listAmount?.map((res) => (
                        <MenuItem
                          key={res.id}
                          value={res.id}
                          className={classes.menuItem}
                        >
                          {res.value}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                />
                <FormHelperText style={{ color: "#f44336", paddingLeft: 10 }}>
                  {errors.hasOwnProperty("pijamaAmount") &&
                    errors["pijamaAmount"].message}
                </FormHelperText>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={2} style={{ marginTop: 20 }}>
            <Grid item xs={12} md={3} lg={3}>
              <Typography component="h6" variant="subtitle1">
                Suéter
              </Typography>
            </Grid>

            <Grid item xs={12} md={2} lg={2}>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.inputForm}
                size="small"
                error={
                  !!errors.hasOwnProperty("sueterSize") &&
                  errors["sueterSize"].message
                }
              >
                <InputLabel htmlFor="outlined-select-sueterSize" shrink={true}>
                  Talla
                </InputLabel>
                <Controller
                  fullWidth
                  control={control}
                  name="sueterSize"
                  inputRef={register}
                  defaultValue=""
                  className={classes.inputForm}
                  label="Talla"
                  size="small"
                  notched={true}
                  inputProps={{
                    name: "sueterSize",
                    id: "outlined-select-sueterSize",
                  }}
                  as={
                    <Select>
                      <MenuItem
                        className={classes.menuItem}
                        aria-label="None"
                        value={null}
                      >
                        <em>&nbsp;</em>
                      </MenuItem>
                      {maestras?.tallaLetras?.map((res) => (
                        <MenuItem
                          key={res}
                          value={res}
                          className={classes.menuItem}
                        >
                          {res}
                        </MenuItem>
                      ))}
                    </Select>
                  }
                />
                <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                  {errors.hasOwnProperty("sueterSize") &&
                    errors["sueterSize"].message}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={6} md={2} lg={2}>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.inputForm}
                size="small"
                error={
                  !!errors.hasOwnProperty("sueterAmount") &&
                  errors["sueterAmount"].message
                }
              >
                <InputLabel
                  htmlFor="outlined-select-sueterAmount"
                  shrink={true}
                >
                  Cantidad
                </InputLabel>
                <Controller
                  fullWidth
                  name="sueterAmount"
                  control={control}
                  size="small"
                  defaultValue=""
                  render={(props) => (
                    <Select
                      inputRef={register}
                      label="Cantidad"
                      notched={true}
                      className={classes.inputForm}
                      inputProps={{
                        name: "sueterAmount",
                        id: "outlined-select-sueterAmount",
                      }}
                      onChange={(e) => {
                        props.onChange(e);
                        onChangeClothes(e, "sueter");
                      }}
                    >
                      <MenuItem
                        className={classes.menuItem}
                        aria-label="None"
                        value={null}
                      >
                        <em>&nbsp;</em>
                      </MenuItem>
                      {listAmount?.map((res) => (
                        <MenuItem
                          key={res.id}
                          value={res.id}
                          className={classes.menuItem}
                        >
                          {res.value}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                />
                <FormHelperText style={{ color: "#f44336", paddingLeft: 10 }}>
                  {errors.hasOwnProperty("sueterAmount") &&
                    errors["sueterAmount"].message}
                </FormHelperText>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={2} style={{ marginTop: 20 }}>
            <Grid item xs={12} md={3} lg={3}>
              <Typography component="h6" variant="subtitle1">
                Pantalón
              </Typography>
            </Grid>

            <Grid item xs={12} md={2} lg={2}>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.inputForm}
                size="small"
                error={
                  !!errors.hasOwnProperty("pantsSize") &&
                  errors["pantsSize"].message
                }
              >
                <InputLabel htmlFor="outlined-select-pantsSize" shrink={true}>
                  Talla
                </InputLabel>
                <Controller
                  fullWidth
                  control={control}
                  name="pantsSize"
                  inputRef={register}
                  defaultValue=""
                  className={classes.inputForm}
                  label="Talla"
                  size="small"
                  notched={true}
                  inputProps={{
                    name: "pantsSize",
                    id: "outlined-select-pantsSize",
                  }}
                  as={
                    <Select>
                      <MenuItem
                        className={classes.menuItem}
                        aria-label="None"
                        value={null}
                      >
                        <em>&nbsp;</em>
                      </MenuItem>
                      {pantsSize && pantsSize?.map((res) => (
                        <MenuItem
                          key={res}
                          value={res}
                          className={classes.menuItem}
                        >
                          {res}
                        </MenuItem>
                      ))}
                    </Select>
                  }
                />
                <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                  {errors.hasOwnProperty("pantsSize") &&
                    errors["pantsSize"].message}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={6} md={2} lg={2}>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.inputForm}
                size="small"
                error={
                  !!errors.hasOwnProperty("pantsAmount") &&
                  errors["pantsAmount"].message
                }
              >
                <InputLabel htmlFor="outlined-select-pantsAmount" shrink={true}>
                  Cantidad
                </InputLabel>
                <Controller
                  fullWidth
                  name="pantsAmount"
                  control={control}
                  size="small"
                  defaultValue=""
                  render={(props) => (
                    <Select
                      inputRef={register}
                      label="Cantidad"
                      notched={true}
                      className={classes.inputForm}
                      inputProps={{
                        name: "pantsAmount",
                        id: "outlined-select-pantsAmount",
                      }}
                      onChange={(e) => {
                        props.onChange(e);
                        onChangeClothes(e, "pants");
                      }}
                    >
                      <MenuItem
                        className={classes.menuItem}
                        aria-label="None"
                        value={null}
                      >
                        <em>&nbsp;</em>
                      </MenuItem>
                      {listAmount?.map((res) => (
                        <MenuItem
                          key={res.id}
                          value={res.id}
                          className={classes.menuItem}
                        >
                          {res.value}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                />
                <FormHelperText style={{ color: "#f44336", paddingLeft: 10 }}>
                  {errors.hasOwnProperty("pantsAmount") &&
                    errors["pantsAmount"].message}
                </FormHelperText>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={2} style={{ marginTop: 20 }}>
            <Grid item xs={12} md={3} lg={3}>
              <Typography component="h6" variant="subtitle1">
                Calzado
              </Typography>
            </Grid>

            <Grid item xs={12} md={2} lg={2}>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.inputForm}
                size="small"
                error={
                  !!errors.hasOwnProperty("shoesSize") &&
                  errors["shoesSize"].message
                }
              >
                <InputLabel htmlFor="outlined-select-shoesSize" shrink={true}>
                  Talla
                </InputLabel>
                <Controller
                  fullWidth
                  control={control}
                  name="shoesSize"
                  inputRef={register}
                  defaultValue=""
                  className={classes.inputForm}
                  label="Talla"
                  size="small"
                  notched={true}
                  inputProps={{
                    name: "shoesSize",
                    id: "outlined-select-shoesSize",
                  }}
                  as={
                    <Select>
                      <MenuItem
                        className={classes.menuItem}
                        aria-label="None"
                        value={null}
                      >
                        <em>&nbsp;</em>
                      </MenuItem>
                      {maestras?.tallaCalzado?.map((res) => (
                        <MenuItem
                          key={res}
                          value={res}
                          className={classes.menuItem}
                        >
                          {res}
                        </MenuItem>
                      ))}
                    </Select>
                  }
                />
                <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                  {errors.hasOwnProperty("shoesSize") &&
                    errors["shoesSize"].message}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={6} md={2} lg={2}>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.inputForm}
                size="small"
                error={
                  !!errors.hasOwnProperty("shoesAmount") &&
                  errors["shoesAmount"].message
                }
              >
                <InputLabel htmlFor="outlined-select-shoesAmount" shrink={true}>
                  Cantidad
                </InputLabel>
                <Controller
                  fullWidth
                  name="shoesAmount"
                  control={control}
                  size="small"
                  defaultValue=""
                  render={(props) => (
                    <Select
                      inputRef={register}
                      label="Cantidad"
                      notched={true}
                      className={classes.inputForm}
                      inputProps={{
                        name: "shoesAmount",
                        id: "outlined-select-shoesAmount",
                      }}
                      onChange={(e) => {
                        props.onChange(e);
                        onChangeClothes(e, "shoes");
                      }}
                    >
                      <MenuItem
                        className={classes.menuItem}
                        aria-label="None"
                        value={null}
                      >
                        <em>&nbsp;</em>
                      </MenuItem>
                      {listAmount?.map((res) => (
                        <MenuItem
                          key={res.id}
                          value={res.id}
                          className={classes.menuItem}
                        >
                          {res.value}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                />
                <FormHelperText style={{ color: "#f44336", paddingLeft: 10 }}>
                  {errors.hasOwnProperty("shoesAmount") &&
                    errors["shoesAmount"].message}
                </FormHelperText>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={2} style={{ marginTop: 20 }}>
            <Grid item xs={12} md={3} lg={3}>
              <Typography component="h6" variant="subtitle1">
                Carnet y porta carnet
              </Typography>
            </Grid>

            <Grid item xs={6} md={2} lg={2}>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.inputForm}
                size="small"
                error={
                  !!errors.hasOwnProperty("licenseAmount") &&
                  errors["licenseAmount"].message
                }
              >
                <InputLabel
                  htmlFor="outlined-select-licenseAmount"
                  shrink={true}
                >
                  Cantidad
                </InputLabel>
                <Controller
                  fullWidth
                  control={control}
                  name="licenseAmount"
                  inputRef={register}
                  defaultValue=""
                  className={classes.inputForm}
                  label="Cantidad"
                  size="small"
                  notched={true}
                  inputProps={{
                    name: "licenseAmount",
                    id: "outlined-select-licenseAmount",
                  }}
                  as={
                    <Select>
                      <MenuItem
                        className={classes.menuItem}
                        aria-label="None"
                        value={null}
                      >
                        <em>&nbsp;</em>
                      </MenuItem>
                      {listAmount?.map((res) => (
                        <MenuItem
                          key={res.id}
                          value={res.id}
                          className={classes.menuItem}
                        >
                          {res.value}
                        </MenuItem>
                      ))}
                    </Select>
                  }
                />
                <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                  {errors.hasOwnProperty("licenseAmount") &&
                    errors["licenseAmount"].message}
                </FormHelperText>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={2} style={{ marginTop: 20 }}>
            <Grid item xs={2} md={1} lg={1} style={{ maxWidth: "40px" }}>
              <StyledCheckbox
                color="success"
                name="checkBox"
                value={isChekedOther}
                defaultChecked={null}
                //checked={isSelectedCheck(data?.id)}
                className={classes.checked}
                onChange={(e) => handleChangeChecked(e)}
                inputProps={{ "aria-label": "primary checkbox" }}
              />
            </Grid>
            <Grid item xs={10} md={11} lg={11}>
              <Typography variant="subtitle1" style={{ marginTop: "5px" }}>
                Otro
              </Typography>
            </Grid>
            {isChekedOther ? (
              <Grid item xs={12} md={12} lg={12}>
                <FormControl
                  variant="outlined"
                  fullWidth
                  size="small"
                  error={
                    !!errors.hasOwnProperty("other") && errors["other"].message
                  }
                >
                  <Controller
                    name="other"
                    control={control}
                    defaultValue=""
                    rules={{ required: true }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        InputLabelProps={{ shrink: true }}
                        type="text"
                        name="other"
                        label="Otro"
                        variant="outlined"
                        size="small"
                        inputRef={register}
                        fullWidth
                        className={classes.inputForm}
                        error={
                          errors.hasOwnProperty("other") &&
                          errors["other"].message
                        }
                      />
                    )}
                  />
                  <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                    {errors.hasOwnProperty("other") && errors["other"].message}
                  </FormHelperText>
                </FormControl>
              </Grid>
            ) : null}
          </Grid>

          <Grid item xs={12} md={12} lg={12} className={classes.contBtns}>
            <Button
              variant="contained"
              className={classes.buttonContinue}
              onClick={navigateToEndowment}
            >
              Cancelar
            </Button>
            &nbsp;&nbsp;
            <Button
              type="submit"
              variant="contained"
              className={classes.buttonContinue}
              disabled={isDisabledBtn}
            >
              Continuar
            </Button>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

export default NextFormEndowment;
